const _version = "3.8.1"
function version() {
    return _version
}
export default version
